import { useEffect, useState } from "react";
import { PartyPopper } from "lucide-react";
import { api } from "@/lib/api";

export const ComebackBanner = () => {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/games/comeback").then(({ data }) => setC(data)).catch(() => {}); }, []);
  if (!c?.active) return null;
  const days = Math.max(1, Math.ceil((new Date(c.ends_at) - Date.now()) / 864e5));
  return (
    <div className="rounded-3xl pink-gradient text-white p-4 sm:p-5 flex items-center gap-3 shadow-lg shadow-rose-200" data-testid="comeback-banner">
      <span className="w-11 h-11 rounded-2xl bg-white/20 flex items-center justify-center shrink-0"><PartyPopper className="w-6 h-6" /></span>
      <div className="min-w-0">
        <p className="font-display font-extrabold leading-tight">Alle Spiele sind zurück!</p>
        {c.claimed
          ? <p className="text-sm text-white/90" data-testid="comeback-claimed">Comeback-Bonus +{c.points} abgeholt ✓</p>
          : <p className="text-sm text-white/90" data-testid="comeback-open">Spiel dein erstes Spiel und hol dir einmalig <b>+{c.points} Punkte</b> · noch {days} {days === 1 ? "Tag" : "Tage"}</p>}
      </div>
    </div>
  );
};
